import {https, httpsFile} from './http.js';

export function show(id,page,currentpage,forPrint = false){
    return https().get(`pr-details/${id}?page=${page}&currentpage=${currentpage}&forPrint=${forPrint}`);
}

export function update(id,data){
    return https().post(`pr-details/${id}`,data);
}

export function create(data){
    return httpsFile().post(`pr-add-materials`,data);
}

export function destroy(id){
    return https().delete(`pr-details/${id}`);
}

export function reduction(data){
    return httpsFile().post(`pr-reduction`,data);
}